import ArrowRight from 'svg/ArrowRight';
import { Button } from 'components/Button';

interface Props {
  onEnterManually: () => void;
}

export default function ManualAddressPrompt({ onEnterManually }: Props) {
  return (
    <div className="pointer-events-none sticky bottom-0 z-10 mt-auto flex justify-end pt-ds-md lg:translate-x-ds-xl lg:translate-y-ds-xl">
      <Button
        variant="secondary"
        size="md"
        isInline
        className="pointer-events-auto rounded-full border-0 bg-color-bg-lightmode-primary shadow-[0px_6px_28px_rgba(0,0,0,0.3)] dark:bg-color-bg-darkmode-primary"
        iconRight={<ArrowRight className="h-4 w-4" />}
        onClick={onEnterManually}
      >
        Can’t find your address?
      </Button>
    </div>
  );
}
